// removed by extract-text-webpack-plugin
module.exports = {"calendar":"Calendar-calendar"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwdatepicker/Calendar.scss
// module id = 359
// module chunks = 0